import React, { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import AppShell from '../layouts/AppShell';
import SocialComments from '../components/SocialComments';
import { buildNavigationItems } from '../utils/navigationConfig';
import { hasPermission, hasAnyPermission } from '../utils/permissionUtils';

const CommentsPage = ({ user, onLogout }) => {
  const canManageTemplates = useMemo(() => hasPermission(user, 'template:manage'), [user]);
  const canManageIntegrations = useMemo(() => hasPermission(user, 'integration:manage'), [user]);
  const canManagePositions = useMemo(() => hasPermission(user, 'position:manage'), [user]);
  const canManageTeams = useMemo(() => hasPermission(user, 'team:manage'), [user]);
  const canViewUserRoster = useMemo(
    () => hasAnyPermission(user, ['position:assign', 'position:manage', 'user:manage']),
    [user]
  );
  const canInviteUsers = useMemo(() => hasPermission(user, 'user:invite'), [user]);
  const canViewStats = useMemo(() => hasPermission(user, 'stats:view'), [user]);
  const canModerateComments = useMemo(() => hasPermission(user, 'comment:moderate'), [user]);

  const navItems = useMemo(
    () =>
      buildNavigationItems({
        canManageTemplates,
        canViewUserRoster,
        canManagePositions,
        canManageTeams,
        canInviteUsers,
        canViewStats,
        canManageIntegrations,
        canModerateComments
      }),
    [canManageTemplates, canViewUserRoster, canManagePositions, canManageTeams, canInviteUsers, canViewStats, canManageIntegrations, canModerateComments]
  );

  if (!canModerateComments) {
    return <Navigate to="/inbox" replace />;
  }

  return (
    <AppShell user={user} navItems={navItems} onLogout={onLogout}>
      <SocialComments
        selectedPlatform="all"
        cacheScope={user?.id || user?.email || 'current-user'}
      />
    </AppShell>
  );
};

export default CommentsPage;
